
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import DoctorConsultAppointmentSerializer from '../types/DoctorConsultAppointmentSerializer_apps_DPO'


const HOST = `${config.API_HOST}`
/* ['generics.ListAPIView'] */
/* params: 'order_div', 'order_user', 'order_doctor', 'start_created_date', 'end_created_date', 'start_app_date', 'end_app_date', 'division', 'consult_user', 'consulted_doctor', 'status', 'app_status', 'encounter_type', 'patient', 'order_encounter', 'encounter' */
/* data:  */
const DoctorConsultAppointmentList : 
{
  list:     ({params, apiToken, extra}:
             { 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  list: async ({params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/DPO/doctor-consult-appointment/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default DoctorConsultAppointmentList

